import { Authorization } from "../../common/AuthorizationCpt";
import icIconDetail from "../../images/ic_detail_icon.svg";
import checkIcon from "../../images/icon_check.svg";
import redCrossIcon from "../../images/icon_cross_red.svg";
import { formatMoney } from "../../utils/numbers";
import {
  ApproveButton,
  RejectButton,
} from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import Sidebar from "../Sidebar/Sidebar";
import {
  ButtonGeneric,
  ButtonsContainer,
  Container,
  HorizontalContainer,
  InfoContainer,
  SectionTitle,
  Subtitle,
  Text,
  Title,
} from "./AdminPaymentValidationSidebarStyles";

function AdminPaymentValidationSidebar(props: any) {
  const {
    sidebarInfo,
    onOutsideClick,
    handleRejectionComment,
    handleAskForAction,
    setShowSidebarModal,
  } = props;
  const {
    agentName,
    invoiceNum,
    bank,
    salesInvoiceTotal,
    paymentCode,
    paymentCurrency,
  } = sidebarInfo;

  return (
    <Sidebar onOutsideClick={onOutsideClick}>
      <Container>
        <div>
          <Subtitle>{invoiceNum}</Subtitle>
          <Title>{agentName}</Title>
          <InfoContainer>
            <p>Recuerda aprobar el pago en un máximo de 20 minutos.</p>
          </InfoContainer>
          <div>
            <SectionTitle>AGENTE DE ADUANA</SectionTitle>
            <Text>{agentName}</Text>
          </div>
          <HorizontalContainer>
            <div>
              <SectionTitle>BANCO</SectionTitle>
              <Text>{bank}</Text>
            </div>
            <div>
              <SectionTitle>MONTO</SectionTitle>
              <Text>
                {formatMoney(salesInvoiceTotal, paymentCurrency === "usd")}
              </Text>
            </div>
          </HorizontalContainer>
          <div>
            <SectionTitle>NÚMERO DE OPERACIÓN</SectionTitle>
            <Text>{paymentCode}</Text>
          </div>
        </div>
        <div>
          <div>
            {sidebarInfo.volantes && (
              <ButtonGeneric
                height="6.2rem"
                marginBottom="2.5rem"
                onClick={() => {
                  setShowSidebarModal(true);
                }}
              >
                <img src={icIconDetail} alt="Aspa" />
                <div style={{ marginLeft: "1.25rem" }}>Ver detalle</div>
              </ButtonGeneric>
            )}
          </div>
          <Authorization actions={["invoice.update_invoice_upfront_manual"]}>
            <ButtonsContainer>
              <ApproveButton
                onClick={() => handleAskForAction(sidebarInfo, "paid")}
              >
                <img src={checkIcon} alt="Check" />
                Aprobar
              </ApproveButton>
              <RejectButton
                onClick={() => handleRejectionComment(sidebarInfo, "rejected")}
              >
                <img src={redCrossIcon} alt="Aspa" />
                Rechazar
              </RejectButton>
            </ButtonsContainer>
          </Authorization>
        </div>
      </Container>
    </Sidebar>
  );
}

export default AdminPaymentValidationSidebar;
